(() => {
  const configElement = document.getElementById('nn-locale-navigation-config');
  if (!configElement) return;
  const config = JSON.parse(configElement.textContent);
  const storeHosts = config.storeHosts || [window.location.hostname];
  const language = config.language || document.documentElement.lang;
  const root = config.root.replace(/\/$/, '');
  const roots = [...new Set([...config.roots, config.routeRoot])]
    .map(value => value.replace(/\/$/, '')).filter(Boolean).sort((a, b) => b.length - a.length);

  function localize(value) {
    if (!value || /^(#|\?|mailto:|tel:|javascript:)/i.test(value)) return value;
    let url;
    try { url = new URL(value, window.location.origin); } catch (_) { return value; }
    const storeLink = storeHosts.includes(url.hostname) && /^https?:$/.test(url.protocol);
    const hostedAccount = config.accountPath && url.hostname === 'shopify.com' &&
      (url.pathname === config.accountPath || url.pathname.startsWith(config.accountPath + '/'));
    if (hostedAccount || (storeLink && /^\/(account|customer_authentication)(\/|$)/.test(url.pathname))) {
      url.searchParams.set('locale', language);
      return url.href;
    }
    if (!storeLink) return value;
    let path = url.pathname;
    const prefix = roots.find(candidate => path === candidate || path.startsWith(candidate + '/'));
    if (prefix) path = path.slice(prefix.length) || '/';
    // Only storefront navigation; leave apps, checkout, downloads and discount links alone.
    if (path !== '/' && !/^\/(collections|products|pages|blogs|policies|search|cart|localization|recommendations)(\/|\.|$)/.test(path)) return value;
    return (root + path) + url.search + (url.hash || (value.endsWith('#') ? '#' : ''));
  }

  function normalize(element) {
    if (element.matches('a[href]:not([hreflang]):not([download])') && !element.closest('[data-localization-form]')) {
      const current = element.getAttribute('href');
      const next = localize(current);
      if (next !== current) element.setAttribute('href', next);
    }
    if (element.matches('form[action]')) {
      const current = element.getAttribute('action');
      const next = localize(current);
      if (next !== current) element.setAttribute('action', next);
    }
  }

  function normalizeTree(node) {
    if (node.nodeType !== 1) return;
    normalize(node);
    node.querySelectorAll('a[href], form[action]').forEach(normalize);
  }

  // Keep Ajax-generated routes consistent with the language actually being viewed.
  window.Shopify.routes.root = root + '/';
  [window.MinimogSettings, window.FoxKitSettings].forEach(settings => {
    if (!settings) return;
    if (settings.routes) Object.keys(settings.routes).forEach(key => {
      settings.routes[key] = localize(settings.routes[key]);
    });
    if (settings.base_url) settings.base_url = window.location.origin + root + '/';
    if (settings.baseUrl) settings.baseUrl = root + '/';
  });

  normalizeTree(document.documentElement);
  new MutationObserver(records => records.forEach(record => {
    if (record.type === 'attributes') normalize(record.target);
    else record.addedNodes.forEach(normalizeTree);
  })).observe(document.documentElement, {childList: true, subtree: true, attributes: true, attributeFilter: ['href', 'action']});

  document.addEventListener('click', event => {
    const link = event.target.closest('a[href]');
    if (link) normalize(link);
  }, true);
  document.addEventListener('submit', event => {
    const form = event.target;
    if (!form.matches('[data-localization-form]')) return;
    const returnTo = form.querySelector('[name="return_to"]');
    if (returnTo) returnTo.value = window.location.pathname + window.location.search + window.location.hash;
  }, true);
})();
